import * as React from 'react'
import { CHAT_LISTENERS } from '$utils/enumsChat'
import { isUserAuthenticated } from '$services/session/isAuthenticated/isAuthenticated.service'
import { chatClient } from '$infrastructure/cometChat/cometChatClient'

export const useUnreadMessages = () => {
  const [isUnreadMessages, setIsUnreadMessages] = React.useState<boolean>(false)

  const removeChatListeners = () => {
    if (isUserAuthenticated()) {
      chatClient.removeMessageListener(CHAT_LISTENERS.unreadMessageListenerId)
    }
  }

  const updateUnreadMessagesState = async () => {
    const getUnreadMessages = await chatClient.getUnreadMessageCount()
    setIsUnreadMessages(getUnreadMessages)
  }

  React.useEffect(() => {
    const unreadMessageActions = async () => {
      if (isUserAuthenticated()) {
        const isUserLogged = await chatClient.getLoggedinUser()
        if (isUserLogged) {
          updateUnreadMessagesState()

          chatClient.addMessageListener(
            CHAT_LISTENERS.unreadMessageListenerId,
            chatClient.messageListener({
              onTextMessageReceived: async textMessage => {
                updateUnreadMessagesState()
              },
            }),
          )
        }
      }
    }

    unreadMessageActions()

    return () => removeChatListeners()
  })

  return isUnreadMessages
}



// WEBPACK FOOTER //
// ./src/utils/hooks/useUnreadMessages.ts